import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { ListPagination } from '@/components/common/ListPagination'
import type { AuditLog } from '@/api/audit'

interface AuditLogTableProps {
	logs: AuditLog[]
	total: number
	page: number
	pageSize: number
	loading: boolean
	error: Error | null
	onPageChange: (page: number) => void
	onPageSizeChange: (pageSize: number) => void
	onSelect: (log: AuditLog) => void
}

function formatOperator(log: AuditLog) {
	if (log.operator_nickname && log.operator_username) return `${log.operator_nickname}（${log.operator_username}）`
	if (log.operator_username) return log.operator_username
	return `用户 #${log.operator_id}`
}

export function AuditLogTable({ logs, total, page, pageSize, loading, error, onPageChange, onPageSizeChange, onSelect }: AuditLogTableProps) {
	if (error) return <div className="rounded-md border border-destructive/30 p-4 text-sm text-destructive">{error.message}</div>
	if (loading) return <div className="rounded-md border p-6 text-sm text-muted-foreground">加载中...</div>
	if (logs.length === 0) return <div className="rounded-md border p-6 text-sm text-muted-foreground">暂无操作日志</div>

	return (
		<div className="space-y-3">
			<div className="rounded-md border">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>操作时间</TableHead>
							<TableHead>操作人</TableHead>
							<TableHead>模块</TableHead>
							<TableHead>操作</TableHead>
							<TableHead>资源编号</TableHead>
							<TableHead>摘要</TableHead>
							<TableHead>结果</TableHead>
							<TableHead>IP</TableHead>
							<TableHead className="w-20 text-right">详情</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{logs.map((log) => (
							<TableRow key={log.id}>
								<TableCell className="whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</TableCell>
								<TableCell>{formatOperator(log)}</TableCell>
								<TableCell>{log.module_label || log.module}</TableCell>
								<TableCell>{log.action_label || log.action}</TableCell>
								<TableCell>{log.resource_no || log.resource_id}</TableCell>
								<TableCell className="max-w-[280px] truncate">{log.summary}</TableCell>
								<TableCell>
									<Badge variant={log.result === 'success' ? 'success' : 'destructive'}>{log.result === 'success' ? '成功' : '失败'}</Badge>
								</TableCell>
								<TableCell>{log.ip}</TableCell>
								<TableCell className="text-right">
									<Button variant="ghost" size="sm" onClick={() => onSelect(log)}>
										查看
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
			<ListPagination
				page={page}
				pageSize={pageSize}
				total={total}
				showPageNumbers={false}
				onPageChange={onPageChange}
				onPageSizeChange={onPageSizeChange}
			/>
		</div>
	)
}
